

























import { Vue, Component } from "vue-property-decorator";
import { PartnerService } from "@/zh-website/src/views/partner/service";

@Component({
  components: {
  }
})
export default class Bidding extends Vue {
  id = "";
  projectInfo = {name: "", description: ""};
  isExpired = false;

  mounted() {
    this.id = this.$route.params.id;
    // 添加用于判断是 c端 还是 b端的 local storage
    PartnerService.getBiddingProject({projectId: this.id}).then((res: any) => {
      if (res.success) {
        this.projectInfo.name = res.data.name;
        this.projectInfo.description = res.data.description;
        this.isExpired = res.data.isExpired;
      } else {
        this.$message.error(res.message);
      }
    });
  }

  toBiddingSubmit() {
    this.$router.push({
      name: "BiddingSubmit"
    });
  }

  toBiddingDownload() {
    this.$router.push({
      name: "BiddingDownload"
    });
  }
}
